"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _Video = _interopRequireDefault(require("../../atoms/Video"));
var _Row = _interopRequireDefault(require("../../foundational/Layout/Row"));
var _Col = _interopRequireDefault(require("../../foundational/Layout/Col"));
var _Carousel = _interopRequireDefault(require("../../molecules/Carousel"));
var _VideoList = _interopRequireDefault(require("../../atoms/VideoList"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "data"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
(function _() {
  var styles = "@media (max-width: 48rem) {\n  .VideoPlaylist__video {\n    padding: 0 2rem 2rem 2rem !important;\n  }\n}\n.VideoPlaylist__list {\n  display: flex;\n  align-items: center;\n}\n.VideoPlaylist__list__carousel .carousel__default_arrow--next {\n  right: -1.5rem !important;\n}\n.VideoPlaylist__list__carousel .carousel__default_arrow--next:before {\n  width: 1rem !important;\n}\n.VideoPlaylist__list__carousel .carousel__default_arrow--next:after {\n  width: 1rem !important;\n  top: 40px !important;\n  right: 0.5rem !important;\n}\n.VideoPlaylist__list__carousel .carousel__default_arrow--prev {\n  left: -0.5rem !important;\n}\n.VideoPlaylist__list__carousel .carousel__default_arrow--prev:before {\n  width: 1rem !important;\n}\n.VideoPlaylist__list__carousel .carousel__default_arrow--prev:after {\n  width: 1rem !important;\n  top: 40px !important;\n  left: 0.5rem !important;\n}\n@media (max-width: 48rem) {\n  .VideoPlaylist__list__carousel {\n    max-width: unset !important;\n  }\n  .VideoPlaylist__list__carousel.one_slide {\n    padding: 0;\n  }\n  .VideoPlaylist__list__carousel .slick-slide div {\n    max-width: unset !important;\n    margin-left: unset !important;\n  }\n  .VideoPlaylist__list__carousel .slick-slide div span {\n    padding: 0 !important;\n    display: unset !important;\n  }\n  .VideoPlaylist__list__carousel .carousel__default_arrow--next {\n    right: -1rem !important;\n  }\n}\n.VideoPlaylist__list__carousel .VideoList {\n  cursor: pointer;\n}\n.VideoPlaylist__list__carousel .slick-slide.slick-active {\n  margin-right: 0.25rem;\n}";
  var fileName = "VideoPlaylist_VideoPlaylist";
  var element = document.querySelector("style[data-sass-component='VideoPlaylist_VideoPlaylist']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
var VideoPlaylist = function VideoPlaylist(_ref) {
  var _snippetVideo$snippet, _snippetVideo$snippet2, _snippetVideo$snippet3, _snippetVideo$snippet4, _snippetVideo$snippet5, _snippetVideo$snippet6, _snippetVideo$snippet7;
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    data = _ref.data,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    groupedArray = _useState2[0],
    setGroupedArray = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    snippetVideo = _useState4[0],
    setSnippetVideo = _useState4[1];
  (0, _react.useEffect)(function () {
    return setSnippetVideo(data && data[0]);
  }, [data]);
  (0, _react.useEffect)(function () {
    setGroupedArray(groupVideos());
  }, [data]);
  var handleImgClick = function handleImgClick(index, secondIndex, video) {
    var sliderArray = (0, _toConsumableArray2["default"])(groupedArray);
    sliderArray[index].splice(secondIndex, 1, snippetVideo);
    setSnippetVideo(video);
    setGroupedArray(sliderArray);
  };

  // it groups videos in pairs in an array. Result will be an array of arrays
  var groupVideos = function groupVideos() {
    var videosToCarousel = data && data.length > 0 && data.filter(function () {
      return (arguments.length <= 1 ? undefined : arguments[1]) !== 0;
    });
    var groupedInTwos = [];
    if (videosToCarousel) {
      for (var i = 0; i < videosToCarousel.length; i += 2) {
        if (videosToCarousel.length > i + 1) {
          groupedInTwos.push([videosToCarousel[i], videosToCarousel[i + 1]]);
        } else {
          groupedInTwos.push([videosToCarousel[i]]);
        }
      }
    }
    return groupedInTwos;
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Row["default"], _objectSpread(_objectSpread({
    className: "VideoPlaylist ".concat(className, " ")
  }, rest), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Col["default"], {
      xs: 6,
      className: "VideoPlaylist__video",
      children: snippetVideo && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Video["default"], {
        title: snippetVideo && (_snippetVideo$snippet = snippetVideo.snippet) != null && _snippetVideo$snippet.title ? (_snippetVideo$snippet2 = snippetVideo.snippet) == null ? void 0 : _snippetVideo$snippet2.title : '',
        youtubeEmbedURL: snippetVideo && "https://www.youtube-nocookie.com/embed/".concat((_snippetVideo$snippet3 = snippetVideo.snippet) == null ? void 0 : (_snippetVideo$snippet4 = _snippetVideo$snippet3.resourceId) == null ? void 0 : _snippetVideo$snippet4.videoId),
        metaThumbnailURL: snippetVideo && ((_snippetVideo$snippet5 = snippetVideo.snippet) == null ? void 0 : (_snippetVideo$snippet6 = _snippetVideo$snippet5.thumbnails) == null ? void 0 : (_snippetVideo$snippet7 = _snippetVideo$snippet6.high) == null ? void 0 : _snippetVideo$snippet7.url)
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Col["default"], {
      xs: 6,
      className: "VideoPlaylist__list PX-0 ",
      tabIndex: 0,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Carousel["default"], {
        slidesToShow: 1,
        arrows: true,
        className: "VideoPlaylist__list__carousel ".concat(groupedArray && groupedArray.length > 1 ? '' : 'one_slide'),
        children: groupedArray && groupedArray.map(function (elements, i) {
          return elements.map(function (video, j) {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_VideoList["default"], {
              thumnailSrc: video.snippet.thumbnails.high.url,
              videoTitle: video.snippet.title,
              videoDesc: video.snippet.description,
              onClick: function onClick() {
                return handleImgClick(i, j, video);
              }
            }, i + j);
          });
        })
      })
    })]
  }));
};
var _default = VideoPlaylist;
exports["default"] = _default;